import React from "react";
import WhiteButton, { WhiteButtonProps } from "./WhiteButton";

export interface WhiteButtonsContainerProps {
  buttons: WhiteButtonProps[];
}

export default function WhiteButtonsContainer({
  buttons,
}: WhiteButtonsContainerProps) {
  return (
    <div className="d-flex flex-wrap gap-2">
      {buttons.map((button, index) => (
        <WhiteButton key={index} {...button} />
      ))}
    </div>
  );
}
